export const PAYMENT_DATA_CHANGED_EVENT = 'payment-data-changed';
